import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  TipCreateInput,
  TipDeleteInput,
  TipUpdateInput,
  TippingModel,
} from './model';

export function useCreateTourTip(
  options?: UseMutationOptions<
    ApiResult<TippingModel>,
    ApiError,
    TipCreateInput
  >,
): UseMutationResult<ApiResult<TippingModel>, ApiError, TipCreateInput> {
  return useMutation<ApiResult<TippingModel>, ApiError, TipCreateInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `tours/${body.tourId}/add-tips`,
        method: 'POST',
        classType: TippingModel,
        body: body.body,
      });
    },
    options,
  );
}

export function useUpdateTourTip(
  options?: UseMutationOptions<
    ApiResult<TippingModel>,
    ApiError,
    TipUpdateInput
  >,
): UseMutationResult<ApiResult<TippingModel>, ApiError, TipUpdateInput> {
  return useMutation<ApiResult<TippingModel>, ApiError, TipUpdateInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `tours/update-tip/${body.tipId}`,
        method: 'PUT',
        classType: TippingModel,
        body: body.body,
      });
    },
    options,
  );
}

export function useVoidTourTip(
  options?: UseMutationOptions<{ message: string }, ApiError, TipDeleteInput>,
): UseMutationResult<{ message: string }, ApiError, TipDeleteInput> {
  return useMutation<{ message: string }, ApiError, TipDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `tours/void-tip/${body.tipId}`,
        method: 'PATCH',
      });
    },
    options,
  );
}
